export const GET_FACEBOOK_PAGES = 'GET_FACEBOOK_PAGES'
export const GET_FACEBOOK_PAGES_FULFILLED = 'GET_FACEBOOK_PAGES_FULFILLED'
export const GET_FACEBOOK_PAGES_REJECTED = 'GET_FACEBOOK_PAGES_REJECTED'

/**
 * @typedef {object} GetFacebookPagesPayload
 * @property {string} retailerAccountId - Retailer Account Id
 */
/**
 * Get Facebook Pages
 * @param {GetFacebookPagesPayload} payload
 */

export const getFacebookPages = (payload) => ({
  type: GET_FACEBOOK_PAGES,
  payload,
})
